import React, { useEffect, useRef, useState } from "react";
// styled components
import {
  notification,
} from "antd";
// import { DownOutlined, UserOutlined } from "@ant-design/icons";
// hooks
import { usePersonaNatural } from "../../../hooks/usePersonaNatural";
// router
import { useNavigate } from "react-router";
import LogoPerfil from "../../../assets/profile.png";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import { RolesService,} from "../../../api/Roles/api-roles-permisos";
import axios from "axios";
import DocumentosService from "../../../api/Documentos/api-documentos";
import getStorageUser from "../../../middlewares/GetStorageUser"
import apiNotificaciones from "../../../api/Notificaciones/api-notificaciones";



const rolesService = new RolesService();

interface IProps {
  activeItem: number;
}

export const MenuUsuario: React.FC<IProps> = (props: IProps) => {
  const {
    cargarInformacionParticipante,
    imageSelected,
    setImageSelected,
  } = usePersonaNatural();
  const navigate = useNavigate();
  const [showLink, setShowLink] = useState<any>(false);

  const [, setEstadoVistaNotificacion] =
    useState<any>(false);
  const [estadoVistaSubsanacion,] =
    useState<any>(false);
  const [user, setUser] = useState<any>({});
  const [notificacionesUsuario, setnotificacionesUsuario] = useState<number>(0);
  const [, setAceptado] = useState<any>();

  const getUser = async () => {
    try {
      const _user = getStorageUser()
      consultarJuradoAceptado(_user.documento);
      consultarNotificacionesUsuario(_user.documento);
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
    cargarInformacionParticipante();
    checkAdminPermissions();

    for (let i in document.getElementsByClassName(
      "container-padding-link-usuario-logeado"
    )) {
      if (!isNaN(parseInt(i))) {
        document
          .getElementsByClassName("container-padding-link-usuario-logeado")
        [i].classList.remove("active-buscar-convocatoria");
      }
    }
    document.getElementsByClassName("container-padding-link-usuario-logeado")[
      props.activeItem
    ].className += " active-buscar-convocatoria";
  }, []);

  const consultarJuradoAceptado = async (userDocumento) => {
    const aceptado = await apiParticipantes.postulacionAceptada(userDocumento);
    setAceptado(aceptado);
  };

  const consultarNotificacionesUsuario = async (userDocumento) => {
    const notificacionesUsuario = await apiNotificaciones.notificacionsRecibidas(userDocumento);
    var countNotificaciones;
    if (notificacionesUsuario.data && notificacionesUsuario.data.length > 0) {
      countNotificaciones = notificacionesUsuario.data.filter((x) => x.estado).length;
    }
    setnotificacionesUsuario(countNotificaciones);
  }

  const checkAdminPermissions = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      return navigate("/login");
    }
    // const { user } = await rolesService.getUser(token);

    const user = getStorageUser()

    if (!user) {
      return navigate("/login");
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_USERS}users/validate/access`,
        { route: "/administrador" },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response.data; // Si la respuesta es exitosa, retornamos los datos
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data?.message;
        if (errorMessage === "Error token invitado invalido (para esta sección)") {
          navigate('/login'); // Redirige a /login si el mensaje coincide
        }
      }
      console.error("Error en la validación:", error);
      throw error; // Relanzamos el error si es otro caso
    }
  };

  const fileImageRef = useRef<any>();
  const openNotification = ({ titulo, descripcion, placement }: any) => {
    notification.info({
      message: titulo,
      description: descripcion,
      placement,
    });
  };
  const guardarFoto = async (e: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (
        e.target.files[0].type === "image/jpeg" ||
        e.target.files[0].type === "image/png"
      ) {
        const { name } = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = () => {
          setImageSelected(URL.createObjectURL(e.target.files[0]));
        };
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        let payload = {
          path_foto: name,
        };
        await apiParticipantes.guardarFoto(payload, 1000000002);
        await DocumentosService.guardarArchivo(formData);
        return openNotification({
          titulo: "Imagen Actualizada",
          // descripcion: "Solo se permiten archivos PNG o JPG",
          placement: "bottomRight",
        });
        // return setJurado({ ...jurado, path_foto: name });
      } else {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos PNG o JPG",
          placement: "bottomRight",
        });
      }
    }
  };
  return (
    <div className="col-12 col-md-6 col-lg-2">
      <div
        style={{
          position: "sticky",
          top: "30%",
          paddingBottom: "6%",
        }}
        className="row-shadow2"
      >
        <div className="justify-content-center container-padding-usuario-logeado">
          <div
            role="button"
            onClick={() => fileImageRef.current.click()}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                fileImageRef.current.click();
              }
            }}
            aria-label="Seleccionar imagen de perfil"
          >
            <img
              src={imageSelected !== "" ? imageSelected : LogoPerfil}
              alt="imagen-perfil"
              width={61.84}
            />
          </div>

          <input
            ref={fileImageRef}
            type="file"
            hidden
            onChange={(e) => {
              guardarFoto(e);
              e.target.value = "";
            }}
          />
          {/* <Avatar size="large" icon={<UserOutlined />} /> */}
        </div>
        <div className="font-family-Montserrat-Regular font-size-14px container-padding-usuario-logeado">
          Hola,
          <span className="font-family-Montserrat-SemiBold">
            {`${user.nombres} ${user.apellidos}`}
          </span>
        </div>
        <hr />
        <div
          className="font-family-Montserrat-SemiBold font-size-14px container-padding-link-usuario-logeado"
          onClick={() => navigate("/usuario/Mispostulaciones")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              navigate("/usuario/Mispostulaciones");
            }
          }}
          role="button"
          style={{ cursor: "pointer" }}
        >
          Mis Proyectos &nbsp;&nbsp;{" "}
          {estadoVistaSubsanacion ? <span>&#128276;</span> : null}
        </div>

        <div
          className="font-family-Montserrat-SemiBold font-size-14px container-padding-link-usuario-logeado"
          onClick={() => navigate("/usuario/MenuJurado")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              navigate("/usuario/MenuJurado");
            }
          }}
          role="button"
          style={{ cursor: "pointer" }}
        >
          Jurado
        </div>
        <div
          className="font-family-Montserrat-SemiBold font-size-14px container-padding-link-usuario-logeado"
          onClick={() => navigate("/usuario/MisBeps")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              navigate("/usuario/MisBeps");
            }
          }}
          role="button"
          style={{ cursor: "pointer" }}
        >
          Beps &nbsp;&nbsp;{" "}
          {estadoVistaSubsanacion ? <span>&#128276;</span> : null}
        </div>

        <div
          className="font-family-Montserrat-SemiBold font-size-14px container-padding-link-usuario-logeado"
          onClick={() => navigate("/usuario/")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              navigate("/usuario/");
            }
          }}
          role="button"
          style={{ cursor: "pointer" }}
        >
          Buscar convocatoria
        </div>

        <div
          className="font-family-Montserrat-SemiBold font-size-14px container-padding-link-usuario-logeado w-100"
          onClick={async () => {
            navigate("/usuario/notificacionesUsuario");
            setEstadoVistaNotificacion(false);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              navigate("/usuario/notificacionesUsuario");
              setEstadoVistaNotificacion(false);
            }
          }}
          role="button"
          style={{ cursor: "pointer" }}
        >
          Notificaciones &nbsp;&nbsp;
          {notificacionesUsuario > 0 && (
            <span className="btn btn-sm" style={{ color: "white", background: "#ff8900" }}>
              {notificacionesUsuario}
            </span>
          )}
        </div>
        {showLink && (
          <div
            className="col-12 font-family-Montserrat-SemiBold font-size-14px container-padding-link-usuario-logeado"
            onClick={() => navigate("/administrador")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                navigate("/administrador");
              }
            }}
            role="button"
            style={{ cursor: "pointer" }}
          >
            Administrador
          </div>
        )}

      </div>
    </div>
  );
};
